export default __webpack_public_path__ + "static/media/partner-mb.e5bf47e4.webp";